import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { OurBrandPageContent } from "./OurBrandPageContent";
import { OurBrandPageHeading } from "./OurBrandPageHeading";
import { OurBrandNextPage } from "./ourBrandNextPage";

export const OurBrand = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "ourBrandPageHeading",
      children: <OurBrandPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "ourBrandPageContent",
      children: <OurBrandPageContent/>
    },
    {
      label: "Next Page",
      key: "ourBrandNextPage",
      children: <OurBrandNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
